import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

// Utils
import useRequest from "../../utils/useRequest";

// Components
import PageWrapper from "../../components/PageWrapper";
import Loader from "../../components/Loader";
import PaperOrderList from "./PaperOrderList";

export default function PaperOrderPage() {
  // HOOKS
  const { id } = useParams();

  // STATES
  const [fabricOrderItems, setFabricOrderItems] = useState([]);
  const [orderStatus, setOrderStatus] = useState("PENDING");

  // ENDPOINTS
  const { loading, error, data, refetch } = useRequest(
    `/getOneFabricOrder/${id}`,
    "GET",
    null,
    {},
    true
  );

  useEffect(() => {
    if (data) {
      setFabricOrderItems(data);
      setOrderStatus(data?.status);
    }
  }, [data]);

  return (
    <PageWrapper withBackButton>
      <div className="u-margin--top_500 u-margin--bottom_500">
        {loading ? (
          <Loader />
        ) : (
          <PaperOrderList
            data={fabricOrderItems}
            setData={setFabricOrderItems}
            orderStatus={orderStatus}
          />
        )}
      </div>
    </PageWrapper>
  );
}
